export enum UserType
{
    OWNER = 'owner',
    CLINICIAN = 'clinician',
    ADMIN = 'admin',
    PATIENT = 'patient'
}
